
export const arCommon = {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.about': 'من نحن',
  'nav.services': 'الخدمات',
  'nav.products': 'المنتجات',
  'nav.projects': 'المشاريع',
  'nav.partners': 'الشركاء',
  'nav.news': 'الأخبار',
  'nav.contact': 'اتصل بنا',
  
  // Common buttons
  'btn.readMore': 'اقرأ المزيد',
  'btn.contact': 'اتصل بنا',
  'btn.consultation': 'استشارة مجانية',
  'btn.viewProjects': 'عرض المشاريع',
  'btn.learnMore': 'تعلم المزيد',
  'btn.callUs': 'اتصل بنا',
  'btn.requestConsultation': 'طلب استشارة',
  'btn.viewDetails': 'عرض التفاصيل',
  'btn.buy': 'شراء',
  'btn.subscribe': 'اشتراك',
  'btn.viewAll': 'عرض الكل',
  'btn.getQuote': 'احصل على عرض سعر',
  'btn.viewCatalog': 'عرض الكتالوج الكامل',
  'btn.contactExperts': 'اتصل بالخبراء',
  
  // Common phrases
  'common.years': 'سنة',
  'common.experience': 'خبرة',
  'common.projects': 'مشاريع',
  'common.customers': 'عملاء',
  'common.readTime': 'دقيقة قراءة',
  'common.location': 'الموقع',
  'common.area': 'المساحة',
  'common.established': 'تأسست',
  'common.employees': 'موظفين',
  'common.specialization': 'التخصص',
  'common.category': 'الفئة',
  'common.tags': 'العلامات',
  'common.date': 'التاريخ',
  'common.search': 'بحث',
  'common.filter': 'تصفية',
  'common.all': 'الكل',
  'common.new': 'جديد',
  'common.found': 'تم العثور عليها',
  'common.searchPlaceholder': 'البحث في المنتجات...',
  
  // Company info
  'company.name': 'Iran GH',
  'company.tagline': 'البيوت المحمية الذكية',
  'company.description': 'مصمم ومنشئ وموزع معدات البيوت المحمية الزجاجية الذكية في إيران',
  'company.phone': '021-88441386',
  'company.email': 'info@irangh.com',
  'company.address': 'طهران، إيران',
  'company.salesManager': '0912-909-5302',
  
  // Footer
  'footer.quickLinks': 'روابط سريعة',
  'footer.services': 'خدماتنا',
  'footer.contactInfo': 'معلومات الاتصال',
  'footer.copyright': '© 2024 Iran GH. جميع الحقوق محفوظة.',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الاستخدام',
  'footer.madeWith': 'Made with Readdy',
  
  // News page
  'news.title': 'آخر الأخبار والمعلومات',
  'news.subtitle': 'ابق على اطلاع بآخر التطورات في تكنولوجيا البيوت المحمية',
  'news.heroTitle': 'آخر الأخبار والمعلومات',
  'news.heroSubtitle': 'آخر الأخبار والتقنيات والابتكارات في عالم البيوت المحمية والزراعة الحديثة',
  'news.featured': 'الأخبار المميزة',
  'news.recent': 'أخبار أخرى',
  'news.categories': 'الفئات',
  'news.searchPlaceholder': 'البحث في الأخبار والمقالات والعلامات...',
  'news.project': 'مشروع',
  'news.technology': 'تكنولوجيا',
  'news.product': 'منتجات',
  'news.international': 'دولية',
  'news.tips': 'نصائح تقنية',
  'news.research': 'بحوث',
  'news.events': 'أحداث',
  'news.all': 'الكل',
  'news.readMore': 'اقرأ المزيد',
  'news.readTime': 'دقيقة',
  'news.date': 'التاريخ',
  'news.category': 'الفئة',
  'news.tags': 'العلامات',
  'news.noResults': 'لم يتم العثور على نتائج',
  'news.noResultsDesc': 'يرجى المحاولة بكلمات مفتاحية أخرى',
  'news.articlesFound': 'مقالة تم العثور عليها',
  'news.newsletter': 'النشرة الإخبارية',
  'news.newsletterTitle': 'الاشتراك في النشرة الإخبارية',
  'news.newsletterDesc': 'احصل على آخر الأخبار والمقالات المتخصصة حول تكنولوجيا البيوت المحمية مباشرة في بريدك الإلكتروني',
  'news.emailPlaceholder': 'عنوان بريدك الإلكتروني',
  'news.subscribe': 'اشتراك',
  
  // News categories
  'news.cat.all': 'الكل',
  'news.cat.project': 'مشروع',
  'news.cat.products': 'منتجات',
  'news.cat.technology': 'تكنولوجيا',
  'news.cat.international': 'دولية',
  'news.cat.tips': 'نصائح تقنية',
  'news.cat.research': 'بحوث',
  'news.cat.events': 'أحداث',
  
  // Contact page
  'contact.title': 'اتصل بنا',
  'contact.subtitle': 'تواصل مع خبراء Iran GH واحصل على استشارة مجانية',
  'contact.phone': 'الاتصال الهاتفي',
  'contact.phoneDesc': 'اتصل بنا للحصول على استشارة فورية',
  'contact.email': 'البريد الإلكتروني',
  'contact.emailDesc': 'أرسل لنا رسائلك',
  'contact.address': 'عنوان المكتب',
  'contact.addressDesc': 'قم بزيارة المكتب لتلقي المشورة شخصياً',
  'contact.fullAddress': 'طهران، شارع وليعصر، رقم 123، الطابق الخامس',
  'contact.formTitle': 'نموذج الاتصال',
  'contact.formDesc': 'املأ النموذج أدناه حتى يتمكن خبراؤنا من التواصل معك في أقرب وقت ممكن',
  'contact.name': 'الاسم الكامل',
  'contact.namePlaceholder': 'أدخل اسمك الكامل',
  'contact.email': 'البريد الإلكتروني',
  'contact.emailPlaceholder': 'أدخل عنوان بريدك الإلكتروني',
  'contact.phoneNumber': 'رقم الهاتف',
  'contact.phonePlaceholder': 'أدخل رقم هاتفك',
  'contact.projectType': 'نوع المشروع',
  'contact.selectProjectType': 'اختر نوع المشروع',
  'contact.commercial': 'تجاري',
  'contact.research': 'بحثي',
  'contact.hydroponic': 'زراعة مائية',
  'contact.traditional': 'تقليدي',
  'contact.consultation': 'استشارة',
  'contact.budget': 'الميزانية التقريبية',
  'contact.selectBudget': 'اختر الميزانية التقريبية',
  'contact.under100k': 'أقل من $100,000',
  'contact.budget100k500k': '$100,000 - $500,000',
  'contact.budget500k1m': '$500,000 - $1,000,000',
  'contact.over1m': 'أكثر من $1,000,000',
  'contact.timeline': 'الإطار الزمني للمشروع',
  'contact.selectTimeline': 'اختر الإطار الزمني المرغوب',
  'contact.immediate': 'فوري',
  'contact.timeline1to3': '1-3 أشهر',
  'contact.timeline3to6': '3-6 أشهر',
  'contact.timeline6plus': 'أكثر من 6 أشهر',
  'contact.subject': 'الموضوع',
  'contact.subjectPlaceholder': 'أدخل موضوع رسالتك',
  'contact.message': 'الرسالة',
  'contact.messagePlaceholder': 'اكتب التفاصيل الكاملة لمشروعك ومتطلباتك...',
  'contact.characters': 'حرف',
  'contact.sendMessage': 'إرسال الرسالة',
  'contact.sending': 'جاري الإرسال...',
  'contact.successMessage': 'تم إرسال رسالتك بنجاح. سيتواصل معك خبراؤنا في أقرب وقت ممكن.',
  'contact.errorMessage': 'خطأ في ارسال الرسالة. يرجى المحاولة مرة أخرى.',
  'contact.location': 'الموقع',
  'contact.officeHours': 'ساعات العمل',
  'contact.saturday': 'السبت',
  'contact.saturdayHours': '8:00 - 17:00',
  'contact.sunday': 'الأحد',
  'contact.sundayHours': '8:00 - 17:00',
  'contact.monday': 'الاثنين',
  'contact.mondayHours': '8:00 - 17:00',
  'contact.tuesday': 'الثلاثاء',
  'contact.tuesdayHours': '8:00 - 17:00',
  'contact.wednesday': 'الأربعاء',
  'contact.wednesdayHours': '8:00 - 17:00',
  'contact.thursday': 'الخميس',
  'contact.thursdayHours': '8:00 - 17:00',
  'contact.friday': 'الجمعة',
  'contact.fridayHours': 'مغلق',
  'contact.emergencySupport': 'الدعم الطارئ',
  'contact.emergencySupportDesc': 'لمشاكل البيوت المحمية العاجلة خارج ساعات العمل',
  'contact.faq': 'الأسئلة الشائعة',
  'contact.faqDesc': 'إجابات على الأسئلة الشائعة حول الاتصال والخدمات',
  'contact.faq.q1': 'كيف يمكنني الحصول على استشارة مجانية؟',
  'contact.faq.a1': 'يمكنك طلب استشارة مجانية عبر الهاتف أو البريد الإلكتروني أو ملء نموذج الاتصال. سيتواصل معنا خبراؤنا في أقرب وقت ممكن.',
  'contact.faq.q2': 'ما هو وقت الاستجابة للرسائل؟',
  'contact.faq.a2': 'عادة ما نرد على رسائلك خلال 24 ساعة.',
  'contact.faq.q3': 'هل من الممكن زيارة موقع المشروع؟',
  'contact.faq.a3': 'نعم، يقوم خبراؤنا بزيارة موقع المشروع لتقييم أكثر تفصيلاً واستشارة متخصصة.',
  'contact.faq.q4': 'ما هي تكلفة الاستشارة وزيارة الموقع؟',
  'contact.faq.a4': 'الاستشارة الأولية وزيارة الموقع للمشاريع الجدية مجانية تماماً. فقط في حالة عدم استمرار التعاون، يتم تحصيل رسوم زيارة الموقع.',
  'contact.faq.q5': 'هل لديكم دعم على مدار الساعة؟',
  'contact.faq.a5': 'نقدم دعماً على مدار الساعة للعملاء الحاليين ومشاكل البيوت المحمية الطارئة. للأسئلة الأخرى، نرد خلال ساعات العمل.',
  
  // UV Thread Product Page
  'product.uvThread.title': 'خيط UV للبيوت المحمية',
  'product.uvThread.subtitle': 'خيط احترافي لربط النباتات في البيوت المحمية',
  'product.uvThread.description': 'خيط UV عالي الجودة للبيوت المحمية من إنتاج Iran GH، مصنوع من البولي بروبيلين مع حماية من الأشعة فوق البنفسجية. مثالي لربط الطماطم والخيار والبقوليات والفلفل في البيوت المحمية.',
  'product.uvThread.specifications': 'المواصفات الفنية',
  'product.uvThread.length': 'الطول',
  'product.uvThread.lengthValue': '2000 متر',
  'product.uvThread.weight': 'الوزن',
  'product.uvThread.weightValue': '2 كيلوغرام',
  'product.uvThread.color': 'اللون',
  'product.uvThread.colorValue': 'أبيض/أخضر',
  'product.uvThread.manufacturer': 'الشركة المصنعة',
  'product.uvThread.manufacturerValue': 'Iran GH',
  'product.uvThread.uvProtection': 'حماية UV',
  'product.uvThread.uvProtectionValue': '4%',
  'product.uvThread.threadType': 'نوع الخيط',
  'product.uvThread.threadTypeValue': 'خيط مبروم',
  'product.uvThread.material': 'المادة',
  'product.uvThread.materialValue': 'PP (بولي بروبيلين)',
  'product.uvThread.tensileStrength': 'قوة الشد',
  'product.uvThread.tensileStrengthValue': '15 كيلوغرام',
  'product.uvThread.features': 'المميزات',
  'product.uvThread.feature1': 'مقاومة الأشعة فوق البنفسجية',
  'product.uvThread.feature1Desc': 'حماية خاصة من أشعة UV تمنع تدهور الخيط',
  'product.uvThread.feature2': 'قوة عالية',
  'product.uvThread.feature2Desc': 'يتحمل وزناً يصل إلى 15 كيلوغرام دون انقطاع',
  'product.uvThread.feature3': 'سهولة التركيب',
  'product.uvThread.feature3Desc': 'سهل الربط ولا ينزلق',
  'product.uvThread.feature4': 'المتانة',
  'product.uvThread.feature4Desc': 'عمر خدمة طويل في ظروف البيوت المحمية',
  'product.uvThread.applications': 'الاستخدامات',
  'product.uvThread.app1': 'الطماطم',
  'product.uvThread.app1Desc': 'ربط سيقان وعناقيد الطماطم',
  'product.uvThread.app2': 'الخيار',
  'product.uvThread.app2Desc': 'دعم أغصان الخيار',
  'product.uvThread.app3': 'البقوليات',
  'product.uvThread.app3Desc': 'ربط الفاصولياء والبازلاء',
  'product.uvThread.app4': 'الفلفل',
  'product.uvThread.app4Desc': 'دعم سيقان الفلفل',
  'product.uvThread.app5': 'النباتات الطبية',
  'product.uvThread.app5Desc': 'ربط النباتات الطبية طويلة القامة',
  'product.uvThread.installationGuide': 'دليل التركيب',
  'product.uvThread.step1': 'الخطوة 1: التحضير',
  'product.uvThread.step1Desc': 'حضر الأدوات اللازمة وحدد نقاط التثبيت',
  'product.uvThread.step2': 'الخطوة 2: تثبيت الجزء العلوي',
  'product.uvThread.step2Desc': 'اربط الخيط بالهيكل العلوي للبيت المحمي',
  'product.uvThread.step3': 'الخطوة 3: ربط النبات',
  'product.uvThread.step3Desc': 'اربط ساق النبات بعناية، دون شد مفرط',
  'product.uvThread.step4': 'الخطوة 4: التعديل',
  'product.uvThread.step4Desc': 'اضبط شد الخيط عند الحاجة',
  'product.uvThread.step5': 'الخطوة 5: المراقبة',
  'product.uvThread.step5Desc': 'افحص حالة الربط بانتظام وعدل عند الحاجة',
  'product.uvThread.maintenance': 'الصيانة',
  'product.uvThread.maintenance1': 'التنظيف',
  'product.uvThread.maintenance1Desc': 'نظف الخيط من الغبار والأوساخ بانتظام',
  'product.uvThread.maintenance2': 'الفحص',
  'product.uvThread.maintenance2Desc': 'افحص سلامة الخيط بشكل دوري',
  'product.uvThread.maintenance3': 'الاستبدال',
  'product.uvThread.maintenance3Desc': 'استبدل الأجزاء التالفة من الخيط',
  'product.uvThread.maintenance4': 'التخزين',
  'product.uvThread.maintenance4Desc': 'احفظ الخيط غير المستخدم في مكان جاف',
  'product.uvThread.relatedProducts': 'المنتجات ذات الصلة',
  'product.uvThread.clips': 'مشابك الربط',
  'product.uvThread.clipsDesc': 'مشابك خاصة لربط النباتات بسرعة',
  'product.uvThread.hooks': 'خطاطيف البيوت المحمية',
  'product.uvThread.hooksDesc': 'خطاطيف لتثبيت الخيط بهيكل البيت المحمي',
  'product.uvThread.tensioners': 'شادات الخيط',
  'product.uvThread.tensionersDesc': 'أجهزة لتعديل شد الخيط',
  'product.uvThread.contactForOrder': 'للطلب تواصل معنا',
  'product.uvThread.contactPhone': 'الهاتف: +98 21 1234 5678',
  'product.uvThread.contactEmail': 'البريد الإلكتروني: info@irangh.com',
  
  // About page
  'about.title': 'حول Iran GH',
  'about.subtitle': 'المزود الرائد لحلول البيوت المحمية الذكية في إيران',
  'about.story': 'قصتنا',
  'about.mission': 'مهمتنا',
  'about.vision': 'رؤيتنا',
  'about.values': 'قيمنا',
  'about.team': 'فريقنا',
  'about.achievements': 'الإنجازات',
  'about.storyText1': 'تأسست Iran GH في عام 2009، وكانت في المقدمة في تكنولوجيا البيوت المحمية في إيران ومنطقة الشرق الأوسط. ما بدأ كشركة هندسية صغيرة نما ليصبح المزود الرائد لحلول البيوت المحمية الذكية.',
  'about.storyText2': 'بدأت رحلتنا بمهمة بسيطة: إحداث ثورة في الزراعة من خلال تقنيات البيوت المحمية المبتكرة. على مر السنين، أكملنا بنجاح أكثر من 200 مشروع، تتراوح من المزارع العائلية الصغيرة إلى العمليات التجارية الكبيرة.',
  'about.storyText3': 'اليوم، نواصل دفع حدود ما هو ممكن في زراعة البيئة المحكومة، مساعدة المزارعين على تحقيق عوائد أعلى باستخدام موارد أقل.',
  'about.missionText': 'مهمتنا هي توفير حلول مستدامة ومبتكرة لزيادة الإنتاجية الزراعية مع الحفاظ على الموارد الطبيعية.',
  'about.visionText': 'رؤيتنا هي أن نصبح الرائد الإقليمي في تكنولوجيا البيوت المحمية الذكية والمساهمة في الأمن الغذائي.',
  'about.valuesText': 'تشمل قيمنا الابتكار والجودة والاستدامة والالتزام برضا العملاء.',
  
  // Duplicate sections removed for brevity (they were exact copies and caused no functional issues)

  // About page hero section
  'about.hero.badge': 'رائدة في صناعة البيوت المحمية',
  'about.hero.title': 'آريا جرين هاوس',
  'about.hero.subtitle': 'المزود الرائد لحلول البيوت المحمية الذكية في إيران',
  'about.hero.description': 'مع أكثر من 15 عاماً من الخبرة في تصميم وبناء وتجهيز البيوت المحمية الحديثة، نساعد المزارعين على تحقيق إنتاجية أعلى باستخدام التقنيات المتقدمة.',
  'about.hero.features.experience': 'خبرة 15 عاماً',
  'about.hero.features.experience_desc': 'في تصميم وبناء البيوت المحمية الحديثة',
  'about.hero.features.international': 'التعاون الدولي',
  'about.hero.features.international_desc': 'مع أكثر الشركات العالمية سمعة',
  'about.hero.cta.contact': 'اتصل بنا',
  'about.hero.cta.projects': 'عرض المشاريع',
  'about.hero.achievement.title': 'أفضل شركة بيوت محمية في إيران',
  'about.hero.achievement.description': 'حاصلة على جوائز متعددة في صناعة الزراعة',
  
  // About page stats
  'about.stats.experience': 'سنة خبرة',
  'about.stats.projects': 'مشروع ناجح',
  'about.stats.area': 'متر مربع بيت محمي',
  'about.stats.customers': 'عميل راضٍ',
  
  // About page story section
  'about.story.title': 'قصتنا',
  'about.story.subtitle': 'رحلة من الفكرة إلى التقدم',
  'about.story.paragraph1': 'تأسست آريا جرين هاوس في عام 2009 بهدف إحداث ثورة في صناعة الزراعة الإيرانية. ما بدأ كشركة هندسية صغيرة أصبح اليوم واحدة من الشركات الرائدة في مجال البيوت المحمية في البلاد.',
  'about.story.paragraph2': 'من خلال الجمع بين المعرفة التقنية المحلية والتقنيات الدولية المتقدمة، تمكنا من إنجاز أكثر من 50 مشروعاً كبيراً بنجاح. من البيوت المحمية العائلية الصغيرة إلى المجمعات التجارية الكبيرة، كلها ضمن مجال خبرتنا.',
  'about.story.paragraph3': 'اليوم، نواصل السير في طريق الابتكار والتحسين المستمر، وهدفنا هو المساعدة في تطوير الزراعة المستدامة والحديثة في إيران والمنطقة.',
  'about.story.image_alt': 'تاريخ شركة آريا جرين هاوس',
  
  // About page mission, vision, values
  'about.mission.title': 'مهمتنا',
  'about.mission.description': 'تقديم حلول مبتكرة ومستدامة لزيادة الإنتاجية الزراعية والحفاظ على الموارد الطبيعية من خلال تصميم وبناء البيوت المحمية الذكية بالمعايير الدولية.',
  'about.vision.title': 'رؤيتنا',
  'about.vision.description': 'أن نصبح الشركة الرائدة والأكثر سمعة في مجال البيوت المحمية في منطقة الشرق الأوسط والمساعدة في ضمان الأمن الغذائي من خلال تطوير الزراعة الحديثة والمستدامة.',
  'about.values.title': 'قيمنا',
  'about.values.description': 'الابتكار والجودة والاستدامة والصدق والالتزام تجاه العملاء والمسؤولية الاجتماعية هي المبادئ الأساسية لأنشطتنا في جميع المشاريع والخدمات.',
  'about.values.section_title': 'قيمنا الأساسية',
  'about.values.section_description': 'المبادئ التي توجه جميع أنشطتنا',
  'about.values.innovation.title': 'الابتكار',
  'about.values.innovation.description': 'البحث دائماً عن حلول جديدة وأفضل للتحديات الزراعية',
  'about.values.quality.title': 'الجودة',
  'about.values.quality.description': 'استخدام أفضل المواد والمعدات بالمعايير الدولية',
  'about.values.service.title': 'الخدمة المتميزة',
  'about.values.service.description': 'تقديم خدمات شاملة من التصميم إلى الدعم بعد البيع',
  'about.values.sustainability.title': 'الاستدامة',
  'about.values.sustainability.description': 'الالتزام بحماية البيئة والاستخدام الأمثل للموارد الطبيعية',
  
  // About page team section
  'about.team.title': 'فريقنا المتخصص',
  'about.team.description': 'يتكون من أفضل المهندسين والمتخصصين في صناعة البيوت المحمية',
  'about.team.ceo.name': 'المهندس أحمد رضائي',
  'about.team.ceo.position': 'الرئيس التنفيذي والمؤسس',
  'about.team.ceo.description': 'مع أكثر من 20 عاماً من الخبرة في صناعة الزراعة وإدارة مشاريع البيوت المحمية الكبيرة',
  'about.team.engineer.name': 'المهندسة فاطمة أحمدي',
  'about.team.engineer.position': 'مديرة التقنية والتصميم',
  'about.team.engineer.description': 'متخصصة في تصميم البيوت المحمية الذكية وأنظمة التحكم في المناخ',
  'about.team.consultant.name': 'الدكتور علي محمدي',
  'about.team.consultant.position': 'مستشار زراعي أول',
  'about.team.consultant.description': 'دكتوراه في الزراعة ومتخصص في الأنظمة المائية والزراعة بدون تربة',
  
  // About page CTA section
  'about.cta.title': 'مستعد للعمل معنا؟',
  'about.cta.description': 'دعنا نناقش كيف يمكننا مساعدتك في تحقيق أهدافك في البيوت المحمية',
  'about.cta.contact': 'اتصل بنا',
  'about.cta.services': 'عرض الخدمات',
};

export default arCommon;
